// import global variables.
import {BODY_ELEMENT} from '../utils/global';

class CopyButton {
    /**
     * URLコピーボタン
     *
     * @constructor
     * @param {HTMLElement} root - ルートとなる要素
     * @param {Object} options - 設定の変更をする際のオブジェクト
     */
    constructor(root, options) {
        const config = {
            toastTimeout: 2000,
            className: {
                input: 'c-form-input',
                button: 'c-button-copy',
                toast: 'p-toast',
                toastText: 'p-toast__text',
                show: 'is-show'
            },
            text: {
                toast: 'リンクをクリップボードにコピーしました'
            }
        };

        // rootが無ければ何もしない
        if (!root) {
            return;
        }

        this.config = Object.assign(config, options);
        this.root = root;
        this.input = this.root.querySelector(`.${this.config.className.input}`);
        this.button = this.createButton();
        this.toast = this.createToast();
        this.toastText = this.toast.firstElementChild;

        this.init();
        this.addEvent();
    }

    /**
     * init - 初期化
     * @return {Void}
     */
    init() {
        this.root.appendChild(this.button);
        BODY_ELEMENT.appendChild(this.toast);
    }

    /**
     * createButton - コピーボタンの生成
     * @return {HTMLElement}
     */
    createButton() {
        const button = document.createElement('button');

        button.type = 'button';
        button.classList.add(this.config.className.button);
        button.textContent = 'コピー';

        return button;
    }

    /**
     * createToast - トースト通知を生成
     * @return {HTMLElement}
     */
    createToast() {
        const toast = document.createElement('div');

        toast.classList.add(this.config.className.toast);
        toast.setAttribute('role', 'status');
        toast.setAttribute('aria-live', 'polite');
        toast.insertAdjacentHTML('beforeend', `<span class="${this.config.className.toastText}" hidden>${this.config.text.toast}</span>`);

        return toast;
    }

    /**
     * addEvent - イベントバインド
     * @return {Void}
     */
    addEvent() {
        this.button.addEventListener('click', this.copy.bind(this));
    }

    /**
     * copy - input要素の内容をクリップボードにコピー
     * @return {Void}
     */
    copy() {
        // コピーを実行
        this.input.select();
        document.execCommand('copy');

        // input要素の内容が読み上げられてしまうためフォーカスはボタンのママにしておく
        this.button.focus();

        // トーストをセット
        this.toastText.hidden = false;

        // 一定時間たったら非表示にする
        window.setTimeout(() => {
            this.toastText.hidden = true;
        }, this.config.toastTimeout);
    }
}

export default () => {
    // コピーボタン設置
    document.querySelectorAll('.js-copy-url').forEach((element) => new CopyButton(element));
};
